import { render } from "./teacherArchives.vue?vue&type=template&id=3b70c48a&scoped=true"
import script from "./teacherArchives.vue?vue&type=script&lang=js"
export * from "./teacherArchives.vue?vue&type=script&lang=js"

import "./teacherArchives.vue?vue&type=style&index=0&id=3b70c48a&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b70c48a"]])

export default __exports__